import { useTranslation } from 'react-i18next';

import { IPropertySettings } from '@/modules/settings/property/types';
import IconWithTitleDescription from '@/shared/components/atoms/IconWithTItleDescription';
import { IIconWithTitleDescriptionProps } from '@/shared/components/atoms/IconWithTItleDescription/IconWithTitleDescription';
import { farmFields } from '@/shared/constant/general';

import PictureFrame from '~/images/shared/picture-frame.svg';

const ViewBasicInfo: React.FC<{ field: IPropertySettings.IPropertyField }> = ({
  field,
}) => {
  const { t } = useTranslation();

  const isFarm = farmFields.some((farmField) => farmField === field.type);

  const area: IIconWithTitleDescriptionProps = {
    icon: <PictureFrame width='24' height='24' />,
    title: t('area'),
    description: `${field.area} ${t(field.areaUnit)}`,
    iconAlignment: 'center',
    titleTypography: {
      className: 'text-surface-10',
      weight: 'semiBold',
      variant: 'subtitle2',
    },
    descriptionTypography: {
      weight: 'medium',
    },
  };

  const items: IIconWithTitleDescriptionProps[] = [
    {
      icon: <PictureFrame width='24' height='24' />,
      title: t('Field Name'),
      description: field.name,
      iconAlignment: 'center',
      titleTypography: {
        className: 'text-surface-10',
        weight: 'semiBold',
        variant: 'subtitle2',
      },
      descriptionTypography: {
        weight: 'medium',
      },
    },
    {
      icon: <PictureFrame width='24' height='24' />,
      title: t('Field Type'),
      description: t(field.type),
      iconAlignment: 'center',
      titleTypography: {
        className: 'text-surface-10',
        weight: 'semiBold',
        variant: 'subtitle2',
      },
      descriptionTypography: {
        weight: 'medium',
      },
    },
    ...(isFarm ? [area] : []),
  ];
  return (
    <div className='grid grid-cols-2 gap-32'>
      {items.map((item, idx) => (
        <IconWithTitleDescription key={`companyBasicInfo${idx}`} item={item} />
      ))}
    </div>
  );
};

export default ViewBasicInfo;
